// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "buttonWrapper-mSUu";
var _3 = "buttons-nCZr";
var _4 = "confirmNotification-MVub";
var _5 = "confirmView-iBb4";
var _6 = "content-IYq2";
var _7 = "#575757";
var _8 = "deleteButton-z7XN";
var _9 = "1.5rem";
var _a = "#dedede";
var _b = "#adf";
var _c = "1rem";
var _d = "#bebebe";
var _e = "padding-Xmzd";
var _f = "saveButton-NSlR";
var _10 = ".8rem";
var _11 = "#000";
export { _1 as "busBlue", _2 as "buttonWrapper", _3 as "buttons", _4 as "confirmNotification", _5 as "confirmView", _6 as "content", _7 as "darkGrey", _8 as "deleteButton", _9 as "extraLargeFontSize", _a as "lightGrey", _b as "lightblue", _c as "mediumFontSize", _d as "mediumLightGrey", _e as "padding", _f as "saveButton", _10 as "smallFontSize", _11 as "unusedNodeColor" }
